import { render } from "./CustomerGroupPricingForZoneExTank.html?vue&type=template&id=4b638521&scoped=true"
import script from "./CustomerGroupPricingForZoneExTank.js?vue&type=script&lang=js"
export * from "./CustomerGroupPricingForZoneExTank.js?vue&type=script&lang=js"

import "./CustomerGroupPricingForZoneExTank.css?vue&type=style&index=0&id=4b638521&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-customer-portal/src/ST.PetroNetworkCustomer.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b638521"]])

export default __exports__